
import { withTranslation } from "react-i18next";
import HolidaysConfig from "../../../components/holidaysConfig";

const CompanyHolidays = (()  => {
    return (      
          <HolidaysConfig/>
  );
});

export default  withTranslation()(CompanyHolidays as any);
